var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"badge bg-danger m-1",on:{"click":_vm.deleteCategory}},[_vm._v("delete")])
}
var staticRenderFns = []

export { render, staticRenderFns }